'use client';

import { useState, useEffect } from 'react';
import Icon from '@/components/ui/AppIcon';

interface TrustBadgeBarProps {
  className?: string;
}

interface Badge {
  id: string;
  icon: string;
  label: string;
  value: string;
}

const TrustBadgeBar = ({ className = '' }: TrustBadgeBarProps) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const badges: Badge[] = [
    { id: '1', icon: 'CheckBadgeIcon', label: 'ISO Certified', value: '9001:2015' },
    { id: '2', icon: 'GlobeAltIcon', label: 'Global Projects', value: '5000+' },
    { id: '3', icon: 'TruckIcon', label: 'Countries Served', value: '85+' },
    { id: '4', icon: 'ShieldCheckIcon', label: 'Quality Guarantee', value: '5 Years' },
    { id: '5', icon: 'ClockIcon', label: 'Production Time', value: '7-15 Days' },
    { id: '6', icon: 'CurrencyDollarIcon', label: 'Cost Savings', value: '40-60%' },
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % badges.length);
    }, 3000);

    return () => clearInterval(interval);
  }, [badges.length]);

  return (
    <div className={`bg-surface border-t border-border ${className}`}>
      <div className="container mx-auto px-5 md:px-10">
        <div className="hidden md:grid md:grid-cols-3 lg:grid-cols-6 gap-6 py-4">
          {badges.map((badge) => (
            <div
              key={badge.id}
              className="flex items-center gap-3 animate-fadeIn"
            >
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                <Icon name={badge.icon as any} size={20} variant="outline" className="text-primary" />
              </div>
              <div className="flex flex-col">
                <span className="font-accent font-semibold text-sm text-primary">{badge.value}</span>
                <span className="font-body text-xs text-text-secondary">{badge.label}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="md:hidden py-4 overflow-hidden">
          <div className="flex items-center justify-center gap-4">
            <div className="flex-shrink-0 w-12 h-12 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={badges[currentIndex].icon as any} size={24} variant="outline" className="text-primary" />
            </div>
            <div className="flex flex-col">
              <span className="font-accent font-semibold text-base text-primary">{badges[currentIndex].value}</span>
              <span className="font-body text-sm text-text-secondary">{badges[currentIndex].label}</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TrustBadgeBar;